import { XButton } from '@orderx/lab/ui';
import React, { useRef, Fragment, useEffect } from 'react';
import './MenuProductCategoryScroller.scss';
import sum from 'lodash/sum';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import clsx from 'clsx';
import kebabCase from 'lodash/kebabCase';
import { startCase } from '../../../util/startCase';

type Input = {
    categories: string[];
    type: 'CATEGORY' | 'SUB_CATEGORY';
    isAnchorLinks?: boolean;
    anchorOffset?: number;
    activeCategory?: string;
    onChange?(category: string): void;
};

export function MenuProductCategoryScroller(input: Input) {
    const { categories, isAnchorLinks, anchorOffset, activeCategory, onChange } = input;

    const ref = useRef<any>();
    const $categoryScroller = ref.current;

    function hasScroller() {
        if (!$categoryScroller) {
            return false;
        }

        const bodyWidth = document.body?.getBoundingClientRect?.()?.width || 0;

        const scrollerWidth = sum(
            Array.from($categoryScroller.querySelectorAll('button')).map((item: any) => item.offsetWidth),
        );

        return bodyWidth < scrollerWidth;
    }

    useEffect(() => {
        if ($categoryScroller && activeCategory) {
            const button = $categoryScroller.querySelector(`.${kebabCase(activeCategory)}`);

            if (button?.offsetLeft) {
                $categoryScroller.scrollTo({
                    left: button.offsetLeft - 16 - 32,
                    behavior: 'smooth',
                });
            }
        }
    }, [$categoryScroller, activeCategory]);

    return (
        <>
            <div className={'MenuProductCategoryScroller'}>
                <div ref={ref} className={'category-container'}>
                    {categories.map((category) => {
                        const button = (
                            <XButton
                                onClick={() => {
                                    onChange?.(category);
                                }}
                                className={clsx(kebabCase(category), { isActive: category === activeCategory })}>
                                {startCase(category)}
                            </XButton>
                        );

                        return (
                            <Fragment key={category}>
                                {isAnchorLinks ? (
                                    <AnchorLink href={`#${kebabCase(category)}`} offset={anchorOffset}>
                                        {button}
                                    </AnchorLink>
                                ) : (
                                    button
                                )}
                            </Fragment>
                        );
                    })}
                </div>

                {hasScroller() && (
                    <XButton
                        icon={'navigate_next'}
                        variant={'filled'}
                        className={'scroll-right'}
                        onClick={() => {
                            $categoryScroller.scrollTo({
                                left: ($categoryScroller.scrollLeft || 0) + 200,
                                behavior: 'smooth',
                            });
                        }}>
                        <div className={'gradient'} />
                    </XButton>
                )}
            </div>
        </>
    );
}
